import { ThemeAssets } from 'chessboard/config/theme-assets';
import { Board } from 'chessboard/model/board/types';
import type { CreateRenderer } from 'chessboard/renderers/config/types';
import { Renderer } from 'chessboard/renderers/config/types';
import { Constants as WebGLConstants3D } from 'chessboard/renderers/webgl/three-d/constants';

/**
 * Dynamically import a renderer.
 */
export function fetchRenderer(type: Renderer.Types): Promise<CreateRenderer.Generator> {
  if (type === Renderer.Types.WebGL3D) {
    return import('renderers/webgl/three-d');
  }

  if (type === Renderer.Types.WebGL2D) {
    return import('renderers/webgl/two-d');
  }

  return import('renderers/default');
}

/**
 * Get the renderer type from board options.
 */
export function getRendererType(boardOptions: Board.Options): Renderer.Types {
  const { Arcade, Natural } = Board.Animation.Types;

  const isReal3d = boardOptions.themeAssets
    ? boardOptions.themeAssets.config.perspective === ThemeAssets.Perspective.REAL_3D
    : boardOptions.pieceStyle === WebGLConstants3D.PieceStyles.Trigger;

  if (isReal3d) {
    return Renderer.Types.WebGL3D;
  }

  if ([Arcade, Natural].includes(boardOptions.animationType)) {
    return Renderer.Types.WebGL2D;
  }

  return Renderer.Types.Default;
}

/**
 * Create the renderer, making an intelligent decision based
 * on piece style and animation type.
 */
export function getRenderer(boardOptions: Board.Options): Promise<CreateRenderer.Generator> {
  return fetchRenderer(getRendererType(boardOptions));
}
